import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('user_id');

  if (!user) {
    // Not logged in — redirect to login
    return <Navigate to="/login" replace />;
  }

  // Logged in — render the child component(s)
  return children;
};

export default ProtectedRoute;
